
<div class="row">
  <div class="col-12" style="margin-top:20px">
    <div class="col-md-12 p-0">
      <label style="font-family: MMCDisplay-Bold,MMC Display,MMC Display,Arial !important; font-weight: 700 !important; font-size: 28px; color: rgb(0, 101, 172); height: 40px; ">Survey Search by Job</label>
    </div>
    <div class="col-md-12 p-0">
      <label style="font-family: Noto Sans, Arial !important; font-size: 18px; color: #001f52; height: 20px; ">Know the job you need benchmark data for but not sure which Mercer survey to select?</label>
      <br />
      <label style="font-family: Noto Sans, Arial !important; font-size: 18px; color: #001f52; height: 20px; ">Let’s find your job and survey. Please select the region you need data for and then enter the Job Title or Job Code to get started.</label>
    <br />
      <label style="font-family: Noto Sans, Arial !important; font-size: 18px; color: #001f52; height: 20px; ">If you want to know all the jobs included within a survey you can also do that here by selecting the survey.</label>
    </div>
    <div class="row col-md-3" style="padding:10px">
      <select id="dlRegions" style="border-color: rgb(140, 140, 140); font-family: 'Noto Sans', Arial, sans-serif; font-size: 18px; color: rgb(18, 18, 18); height: 48px; " (change)="onRegionChange($event.target.value)">
        <option value="0" selected>United States/Canada</option>
        <option *ngFor="let region of Regions" value="{{region.CultureCode}}">{{region.Name}}   </option>
      </select>
    </div>
    <div class="row col-md-12" style="padding-left: 5px;">
      <table class="table col-12">
        <tr>
          <th style="background-color: #ffffff; border: none; padding-left: 5px;">
            <input type="text" style="font-size: 18px; border-color: rgb(140, 140, 140); font-family: 'Noto Sans', Arial, sans-serif; float: left; height: 51px !important; width: 57% " placeholder="Search by Job Code or Job Title" [(ngModel)]="searchData" [ngModelOptions]="{standalone:true}" class="col-md-9 searchBox" />
            <button class="col-md-6 MaintBlueButton p-6 m-0" style="width: 20%; margin-left: 10px !important; height: 50px;" (click)="SearchByText()">Search</button>
            <button class="col-md-6 MaintBlueButton p-6 m-0" style="width: 20%; margin-left: 10px !important; height: 50px;" (click)="ClearSearch()">Clear Search</button>
          </th>
        </tr>
      </table>
    </div>
    <div class="row col-md-12">
      <label _ngcontent-c0="" style="font-family: MMCDisplay-Bold,MMC Display,MMC Display,Arial !important; font-weight: 700 !important; font-size: 28px; color: rgb(0, 101, 172); height: 40px; ">OR</label>
    </div>
    <div class="row col-md-6" style="padding-left: 10px; padding-bottom: 40px;">
      <select id="dlSurveys" style="border-color: rgb(140, 140, 140); font-family: 'Noto Sans', Arial, sans-serif; font-size: 18px; color: rgb(18, 18, 18); height: 48px; " (change)="onSurveyChange($event)">
        <option *ngFor="let Survey of Surveys" value="{{Survey.SurveyId}}">{{Survey.SurveyName}}</option>
      </select>
    </div>
    <div class="divider" style="max-width: 1400px;"></div>
    <div *ngIf="filteredsearchresults && filteredsearchresults.length > 0" class="row col-md-6" style="padding-top: 20px;margin-left: -20px;">
      <label for="options" style="font-family: MMCDisplay-Bold,MMC Display,MMC Display,Arial !important; color: rgb(0, 101, 172); font-weight: 500; "> Showing Results {{resultsDisplayString}}</label>
    </div>
    <div *ngIf="filteredsearchresults && filteredsearchresults.length > 0" class="row col-md-6" style="padding-top:20px">
      <ul *ngIf="pager.pages && pager.pages.length" class="pagination" style=" margin-left: -10px;">
        <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item borderradius">
          <a (click)="setPage(1)" class="page-link pagingA">First</a>
        </li>
        <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item">
          <a (click)="setPage(pager.currentPage - 1)" class="page-link pagingA">Previous</a>
        </li>
        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}" class="page-item">
          <a (click)="setPage(page)" [ngClass]="{disabled:page === pager.currentPage}" class="page-link pagingA">{{page}}</a>
        </li>
        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item">
          <a (click)="setPage(pager.currentPage + 1)" class="page-link pagingA">Next</a>
        </li>
        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item borderradius">
          <a (click)="setPage(pager.totalPages)" class="page-link pagingA">Last</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="col-md-12 nopadding" style="margin-top: 20px;">
    <div class="col-12 nopadding">
      <div class="col-12 nopadding">
        <table class="table col-12">
          <tr *ngIf="filteredsearchresults && filteredsearchresults.length>0">
            <th style="width: 200px;" class="HeaderColumns">Survey</th>
            <th style="width: 150px;" class="HeaderColumns">
              Job Code
              <a style="padding-left: 0px; text-decoration: none !important" class="SurveyJobsLink" href="#" (click)="SortByJobCode()">
                <svg version="1.2" preserveAspectRatio="none" viewBox="0 0 24 24" class="ng-element" data-id="6644e09b4ff3439abd38d95e831e8b86" style="opacity: 1;mix-blend-mode: normal;fill: rgb(255, 255, 255);width: 30px;height: 30px;padding: 0px;/* transform: rotate(0deg) translate(497px, 466px); */"><g><path xmlns:default="http://www.w3.org/2000/svg" id="sort-down" d="M17.13,9.2C17.01,9.08,16.84,9,16.66,9H7.34C6.97,9,6.68,9.29,6.67,9.66c0,0.18,0.07,0.35,0.2,0.48  l4.66,4.66c0.25,0.26,0.66,0.27,0.92,0.02c0.01-0.01,0.01-0.01,0.02-0.02l4.66-4.66c0.26-0.25,0.27-0.66,0.02-0.92  C17.14,9.21,17.14,9.21,17.13,9.2z" style="fill: rgb(255, 255, 255);"></path></g></svg>
              </a>
            </th>
            <th style="width: 200px;" class="HeaderColumns">
              Job Title
              <a style="padding-left: 0px; text-decoration: none !important" class="SurveyJobsLink" href="#" (click)="SortByPositionTitle()">
                <svg version="1.2" preserveAspectRatio="none" viewBox="0 0 24 24" class="ng-element" data-id="6644e09b4ff3439abd38d95e831e8b86" style="opacity: 1;mix-blend-mode: normal;fill: rgb(255, 255, 255);width: 30px;height: 30px;padding: 0px;/* transform: rotate(0deg) translate(497px, 466px); */"><g><path xmlns:default="http://www.w3.org/2000/svg" id="sort-down" d="M17.13,9.2C17.01,9.08,16.84,9,16.66,9H7.34C6.97,9,6.68,9.29,6.67,9.66c0,0.18,0.07,0.35,0.2,0.48  l4.66,4.66c0.25,0.26,0.66,0.27,0.92,0.02c0.01-0.01,0.01-0.01,0.02-0.02l4.66-4.66c0.26-0.25,0.27-0.66,0.02-0.92  C17.14,9.21,17.14,9.21,17.13,9.2z" style="fill: rgb(255, 255, 255);"></path></g></svg>
              </a>
            </th>
            <th style="width: 460px; border-right: 1px solid grey;" class="HeaderColumns">Description</th>
          </tr>
          <tr *ngFor="let filtered of filteredsearchresults;" style="border-right: 1px solid grey; border-left: 1px solid grey;">
            <td class="colcommonwidth"><a href="{{filtered.SurveyLink}}">{{filtered.SurveyName}}</a></td>
            <td class="ColumnTextBold">{{filtered.JobCode}}</td>
            <td class="ColumnTextBold">{{filtered.PositionTitle}}</td>
            <td class="ColumnText" style="font-weight:400">{{filtered.PositionDescription}}</td>
          </tr>
        </table>
        <div *ngIf="filteredsearchresults && filteredsearchresults.length > 0" class="row">
          <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
            <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item borderradius">
              <a (click)="setPage(1)" class="page-link pagingA">First</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item">
              <a (click)="setPage(pager.currentPage - 1)" class="page-link pagingA">Previous</a>
            </li>
            <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}" class="page-item">
              <a (click)="setPage(page)" [ngClass]="{disabled:page === pager.currentPage}" class="page-link pagingA">{{page}}</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item">
              <a (click)="setPage(pager.currentPage + 1)" class="page-link pagingA">Next</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item borderradius">
              <a (click)="setPage(pager.totalPages)" class="page-link pagingA">Last</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="noitemsinSearch" class="col-12 nopadding">
    <div class="nopadding nofilesTodownload">
      No Jobs Found.
    </div>
  </div>
  <div *ngIf="!surveySelected" class="col-12 nopadding">
    <div class="nopadding nofilesTodownload">
      Please select Survey to proceed.
    </div>
  </div>
  <div class="col-12 overlay ppAjaxLoader" *ngIf="!loadPage">
  </div>
</div>


